// Something that went wrong next to a request that itself succeeded - sent by the backend in the
// X-Request-Warnings response header (backend/DTO/request_warning_dto.py); apiClient shows its message.
export enum RequestWarning {
  FAMILY_INSIGHTS_NOT_RECALCULATED = "FAMILY_INSIGHTS_NOT_RECALCULATED",
}

export const REQUEST_WARNINGS_HEADER = "x-request-warnings";

export const REQUEST_WARNING_MESSAGES: Record<RequestWarning, string> = {
  [RequestWarning.FAMILY_INSIGHTS_NOT_RECALCULATED]: "המשפחה נשמרה, אך התובנות של בני המשפחה לא עודכנו. נסו שוב מאוחר יותר.",
};
